import React from "react";
import style from "./style.module.scss"
const LoadingScreen = () => {
    return (
        <div className={style.loadingContainer}>
            <div className={style.spinner}></div>
            <p className={style.loadingText} style={{textAlign: "center"}}>Creating magic... your content will be <br/> ready soon!</p>
        </div>
    );
};

export default LoadingScreen;
